import InputAdornment from "@mui/material/InputAdornment";
import SvgIcon from "@mui/material/SvgIcon";
import TextField from "@mui/material/TextField";

export default function TextFieldStyled({
  placeholder,
  onChange,
  startAdornment,
}) {
  const handleInputChanged = (event) => {
    if (onChange) {
      onChange(event);
    }
  };

  return (
    <>
      <TextField
        sx={{
          height: "2.625rem",
          "&:hover": {
            "& .MuiFilledInput-root": {
              backgroundColor: "#F7F7F7",
            },
          },
        }}
        fullWidth
        placeholder={placeholder}
        variant="filled"
        onChange={handleInputChanged}
        InputProps={{
          startAdornment: startAdornment && (
            <InputAdornment
              position="start"
              sx={{ marginTop: "0.125rem !important" }}
            >
              <SvgIcon>{startAdornment}</SvgIcon>
            </InputAdornment>
          ),
        }}
      />
    </>
  );
}
